import React from 'react';
import { useTranslation } from 'react-i18next';

const InviteParticipantsModal = ({ getRoomLink, setShowInviteModal, handleCopyLink, copySuccess }) => {
  const { t } = useTranslation();
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 32, width: 460, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ fontSize: 17, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>{t('screens.video.group.inviteParticipants')}</div>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>{t('screens.video.group.inviteShareLink')}</div>
        <div
          style={{
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            padding: '10px 14px',
            fontSize: 12,
            fontFamily: 'monospace',
            color: '#334155',
            wordBreak: 'break-all',
            marginBottom: 20,
          }}
        >
          {getRoomLink()}
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={() => setShowInviteModal(false)}
            style={{ padding: '8px 18px', border: '1px solid #e2e8f0', borderRadius: 8, background: '#fff', fontSize: 13, cursor: 'pointer', color: '#64748b' }}
          >
            {t('screens.video.group.closeBtn')}
          </button>
          <button
            onClick={handleCopyLink}
            style={{
              padding: '8px 18px',
              border: 'none',
              borderRadius: 8,
              background: copySuccess ? '#10b981' : '#7c3aed',
              color: '#fff',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {copySuccess ? t('screens.video.group.copiedCheck') : t('screens.video.group.copyLink')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InviteParticipantsModal;
